import { DISPLAYED_CALENDAR_TABLE_VIEW } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_table/displayedCalendarTableView';
import { useDateTableColumns } from './DateTableColumns';
import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import ManageCompetitorColumnsOrderDrawer
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_table/fragment/ManageCompetitorColumnsOrderDrawer';
import useDrawer from '@ui/drawer/DrawerRef';
import CalendarMonth from '@app/state/calendar/CalendarMonth';


const ManageCompetitorColumnsOrderComponent: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	calendarMonth: CalendarMonth
}>
	= ({ companyHotel, calendarMonth }) => {

	const drawer = useDrawer();
	const columns = useDateTableColumns();
	const dateTable = DISPLAYED_CALENDAR_TABLE_VIEW === 'CLASSIC';

	return <>
		<Menu as="div" className="relative">
			<MenuButton type="button" className="btn btn-white text-xs h-8 px-2.5 relative">
				<EllipsisVerticalIcon className="h-3 w-3 flex-shrink-0" />
			</MenuButton>

			<MenuItems anchor="bottom end"
				className="z-10 mt-3 w-56 origin-top-right overflow-hidden rounded-md bg-white divide-y divide-gray-100 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
				<div className="px-4 py-3">
					<p className="text-xs text-gray-500">
						{dateTable ? 'Show, hide, and reorder date-table columns.' : 'Rearrange the order of the competitors.'}
					</p>
				</div>
				<div className="py-1">
					<MenuItem>
						<a
							onClick={event => { event.preventDefault(); dateTable ? columns.openColumnOrder() : drawer.open(); }}
							href="#"
							className="text-gray-900 relative block px-4 py-2 text-xs">
							<span className="font-semibold block">{dateTable ? 'Column order' : 'Competitors Order'}</span>
						</a>
					</MenuItem>
				</div>
			</MenuItems>
		</Menu>
		<ManageCompetitorColumnsOrderDrawer companyHotel={companyHotel} calendarMonth={calendarMonth} ref={drawer.ref} />
	</>;
};

export default ManageCompetitorColumnsOrderComponent;
